import React from 'react';
// CONTAINERS
import Home from '../Home';

class App extends React.Component {
  render() {    
    return (
      <div
        name="root"
        className="screen root-screen no-padding-screen"
        id="screen__root"
      >
        <Home />
      </div>
    );
  }
}

export default App;
